module.exports = __webpack_public_path__ + "img/transport02.e7fba225.png";